export const rentKeys = {
  catalog: (paramsString: string) => ['rent-catalog', paramsString],
  search: (query: string, langugage: string) => [
    'rent-search',
    query,
    langugage,
  ],
  suggest: () => ['rent-suggest'],
} as const;
